import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  { patch } from "../../lib/request";;

export const updateAlertGroup = createAsyncThunk(
  "alertGroup/update",
  async ({ groupId, payload }, { rejectWithValue }) => {
    try {
      const res = await patch(
        `alert-groups/${groupId}`,
        payload
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update alert group"
      );
    }
  }
);

const alertGroupUpdateSlice = createSlice({
  name: "alertGroupUpdate",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetAlertGroupUpdate(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAlertGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAlertGroup.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateAlertGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetAlertGroupUpdate } = alertGroupUpdateSlice.actions;
export default alertGroupUpdateSlice.reducer;
